const STRIPE_KEYS = {
  LIVE: 'pk_live_3DaeYayFezHhyNjDyzM4Ayhe',
  TEST: 'pk_test_OrZjggCA88Y1wOldz9nJxvMr',
}

const ENV = process.env.GATSBY_CONFIG || 'production'

const baseConfig = {
  apollo: {
    connectToDevTools: ENV !== 'production',
  },
  gaMeasurementId: 'G-HGHKTPS5V7',

  graphqlSchemaVersion: 5, // Bumb when schema changes
  oauthEndpoint: 'https://oauth.nightzookeeper.com',
  oauthClientId: '6495b15a2cb8503abe6113b07579e3df',
  lessonV3EditorUrl:
    process.env.GATSBY_LESSON_V3_EDITOR_URL ||
    'https://app.nightzookeeper.com/lesson-v3/editor',
}

const configs = {
  localDebug: {
    env: 'development',
    url: 'http://localhost:8000',
    eduServer: 'http://192.168.1.94:8080',
    edu: 'http://192.168.1.94:8000/edu/zoo/status',
    graphqlEndpoint: 'http://localhost:8080/graphql',
    stripeKey: STRIPE_KEYS.TEST,
    ...baseConfig,
  },
  local: {
    env: 'development',
    url: 'http://localhost:8000',
    edu: 'http://localhost:3000/edu/zoo/login',
    eduRoot: 'http://localhost:3000',
    eduServer: 'http://localhost:8080',
    graphqlEndpoint: 'http://localhost:8080/graphql',
    // eduServer: 'https://gql-app.nightzookeeper.com',
    // graphqlEndpoint: 'https://gql-app.nightzookeeper.com/graphql',
    // eduServer: 'https://nzk-edu-server-pr-194-917924228180.europe-west2.run.app',
    // graphqlEndpoint: 'https://nzk-edu-server-pr-194-917924228180.europe-west2.run.app/graphql',
    // stripeKey: STRIPE_KEYS.LIVE,
    stripeKey: 'pk_test_51TESbqS1EYIza5vEJyGCtbyzGoSSOno9yUkV0VtMJJYpD1nnPacBmSC5BtdMBRcHj7TCWcjvBxOiEpCega61pK1C00OLN8ymDx',
    // stripeKey: STRIPE_KEYS.TEST,
    ...baseConfig,
    // oauthEndpoint: 'http://localhost:5000',
    // oauthClientId: '2c2501321d0f8439ac82c44e4a767927',
  },
  staging: {
    env: 'staging',
    url: 'https://nzk-parent-dashboard--pr10-feature-account-owne-bdswrvvf.web.app',
    eduServer: 'https://gql-staging.nightzookeeper.com',
    graphqlEndpoint: 'https://gql-staging.nightzookeeper.com/graphql',
    edu: 'https://app.nightzookeeper.com/zoo/status',
    eduRoot: 'https://app.nightzookeeper.com',
    stripeKey: STRIPE_KEYS.LIVE,
    ...baseConfig,
  },
  production: {
    env: 'production',
    url: 'https://dashboard.nightzookeeper.com',
    eduServer: 'https://gql-app.nightzookeeper.com',
    graphqlEndpoint: 'https://gql-app.nightzookeeper.com/graphql',
    edu: 'https://app.nightzookeeper.com/zoo/status',
    eduRoot: 'https://app.nightzookeeper.com',
    stripeKey: STRIPE_KEYS.LIVE,
    ...baseConfig,
  },
}

export default configs[ENV]
